import { Grid, GridItem, IconWarning, Informer } from 'uikit';
import type { DefaultItem } from 'uikit';
import { requiredBaseRule } from 'utils/constants';

import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
import type { Control } from 'react-hook-form';

import { ControlledPatternField, ControlledSelectField, ControlledTextField, ControlNumberField } from '../Form';

import Styles from './EditMtrForm.module.css';

interface IDisabledFieldRules {
    code?: boolean;
    key?: boolean;
    name?: boolean;
    unit?: boolean;
    unitWeight?: boolean;
    unitCost?: boolean;
    supplyBy?: boolean;
    mtrType?: boolean;
    justification?: boolean;
}
export const EditMtrForm = forwardRef(
    (
        {
            control,
            supplyByItems,
            mtrTypeItems,
            hideInformer,
            informerText,
            disabledFieldRules,
        }: {
            control: Control;
            supplyByItems: DefaultItem[];
            mtrTypeItems: DefaultItem[];
            hideInformer?: boolean;
            informerText?: string;
            disabledFieldRules?: IDisabledFieldRules;
        },
        ref: ForwardedRef<HTMLFormElement>,
    ) => (
        <>
            {!hideInformer && (
                <div className={Styles.paddingBlock}>
                    <Informer
                        view="filled"
                        status="warning"
                        label={informerText}
                        style={{ marginBottom: '24px', maxWidth: '500px' }}
                        icon={IconWarning}
                        size="s"
                    />
                </div>
            )}
            <form ref={ref} style={{ width: '100%' }}>
                <div className={Styles.paddingBlock}>
                    <Grid rowGap="s" cols="1">
                        <GridItem>
                            {disabledFieldRules?.code ? (
                                <ControlledTextField name="code" label="Шифр" control={control} type="text" disabled />
                            ) : (
                                <ControlledPatternField
                                    name="code"
                                    control={control}
                                    label="Шифр"
                                    format="####"
                                    rules={{
                                        ...requiredBaseRule,
                                        validate: (val) => {
                                            if (val === '0000') {
                                                return 'Шифр МТР не может быть нулевым';
                                            }

                                            if (val && val.split(' ').length !== 1) {
                                                return "Шифр МТР не соответствует маске 'хххх', где х - цифра от 0 до 9";
                                            }

                                            return true;
                                        },
                                    }}
                                />
                            )}
                        </GridItem>
                        <GridItem>
                            <ControlledTextField
                                name="name"
                                label="Наименование"
                                control={control}
                                type="textarea"
                                disabled={disabledFieldRules?.name ?? true}
                            />
                        </GridItem>
                        <GridItem>
                            <ControlledTextField
                                name="unit"
                                label="Ед. изм."
                                control={control}
                                disabled={disabledFieldRules?.unit ?? true}
                            />
                        </GridItem>
                        <GridItem>
                            <ControlNumberField
                                name="unitWeight"
                                label="Вес, т."
                                control={control}
                                labelPosition="left"
                                size="s"
                                width="full"
                                disabled={disabledFieldRules?.unitWeight ?? false}
                            />
                        </GridItem>
                        <GridItem>
                            <ControlNumberField
                                name="unitCost"
                                label="Стоимость единицы руб. без НДС"
                                labelPosition="left"
                                control={control}
                                size="s"
                                type="number"
                                rules={requiredBaseRule}
                                width="full"
                                disabled={disabledFieldRules?.unitCost ?? false}
                            />
                        </GridItem>
                        <GridItem>
                            <ControlledSelectField
                                name="supplyBy"
                                label="Поставка"
                                control={control}
                                items={supplyByItems}
                                rules={requiredBaseRule}
                                disabled={disabledFieldRules?.supplyBy ?? false}
                            />
                        </GridItem>
                        <GridItem>
                            <ControlledSelectField
                                name="mtrType"
                                label="Тип"
                                control={control}
                                items={mtrTypeItems}
                                rules={requiredBaseRule}
                                disabled={disabledFieldRules?.mtrType ?? false}
                            />
                        </GridItem>

                        <GridItem>
                            <ControlledTextField
                                name="key"
                                label="Код"
                                control={control}
                                type="text"
                                disabled={disabledFieldRules?.key ?? false}
                            />
                        </GridItem>

                        <GridItem>
                            <ControlledTextField
                                name="justification"
                                label="Обоснование"
                                control={control}
                                type="textarea"
                                rules={requiredBaseRule}
                                disabled={disabledFieldRules?.justification ?? false}
                            />
                        </GridItem>
                    </Grid>
                </div>
            </form>
        </>
    ),
);

EditMtrForm.displayName = 'EditMtrForm';
